export default function CheckIcon() {
  return (
    <>
      <polyline points='20 6 9 17 4 12' fill='none' />
    </>
  );
}
